module.exports = __webpack_public_path__ + "img/img_platform03.3d44079f.jpg";